import { resolveComponent as _resolveComponent, createVNode as _createVNode, withKeys as _withKeys, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, toDisplayString as _toDisplayString, withModifiers as _withModifiers, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4cec9618"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h2", null, [
  /*#__PURE__*/_createElementVNode("b", null, "MLP Corals")
], -1))
const _hoisted_2 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_app_download_toolbar = _resolveComponent("app-download-toolbar")!
  const _component_get_gift_toolbar = _resolveComponent("get-gift-toolbar")!
  const _component_ion_searchbar = _resolveComponent("ion-searchbar")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_back_button = _resolveComponent("ion-back-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_cart_button = _resolveComponent("cart-button")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_popover = _resolveComponent("ion-popover")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_refresher_content = _resolveComponent("ion-refresher-content")!
  const _component_ion_refresher = _resolveComponent("ion-refresher")!
  const _component_loading_skeleton = _resolveComponent("loading-skeleton")!
  const _component_product_card = _resolveComponent("product-card")!
  const _component_ion_infinite_scroll_content = _resolveComponent("ion-infinite-scroll-content")!
  const _component_ion_infinite_scroll = _resolveComponent("ion-infinite-scroll")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_header, null, {
        default: _withCtx(() => [
          _createVNode(_component_ion_grid, {
            class: "ion-no-padding",
            fixed: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_app_download_toolbar),
              _createVNode(_component_get_gift_toolbar),
              ($setup.showSearchBar)
                ? (_openBlock(), _createBlock(_component_ion_toolbar, { key: 0 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_searchbar, {
                        ref: "productSearchBar",
                        class: "product-searchbar",
                        mode: "md",
                        modelValue: $setup.searchKeyword,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.searchKeyword) = $event)),
                        placeholder: $setup.t('search'),
                        onIonFocus: _cache[1] || (_cache[1] = ($event: any) => ($setup.isSearching = true)),
                        onIonBlur: _cache[2] || (_cache[2] = ($event: any) => ($setup.isSearching = false)),
                        onKeyup: _cache[3] || (_cache[3] = _withKeys((e) => e.target.blur(), ["enter"])),
                        "cancel-button-text": $setup.t('cancel'),
                        "show-cancel-button": "always",
                        onIonCancel: _cache[4] || (_cache[4] = ($event: any) => {$setup.showSearchBar = false; $setup.searchKeyword = ''})
                      }, null, 8, ["modelValue", "placeholder", "cancel-button-text"])
                    ]),
                    _: 1
                  }))
                : (_openBlock(), _createBlock(_component_ion_toolbar, { key: 1 }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_buttons, { slot: "start" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_back_button, {
                            class: "back-icon",
                            "default-href": $setup.parentPath || '/'
                          }, null, 8, ["default-href"])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_title, { class: "ion-text-start" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, {
                            color: "primary",
                            class: "ion-text-wrap"
                          }, {
                            default: _withCtx(() => [
                              _hoisted_1
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_ion_buttons, { slot: "end" }, {
                        default: _withCtx(() => [
                          _withDirectives(_createVNode(_component_ion_button, {
                            onClick: _cache[5] || (_cache[5] = ($event: any) => ($setup.openUserGiftsModal()))
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_icon, {
                                slot: "icon-only",
                                color: "tertiary",
                                icon: $setup.giftOutline
                              }, null, 8, ["icon"])
                            ]),
                            _: 1
                          }, 512), [
                            [_vShow, $setup.userDiscounts.length > 0]
                          ]),
                          (!$setup.showSearchBar)
                            ? (_openBlock(), _createBlock(_component_ion_button, {
                                key: 0,
                                onClick: _cache[6] || (_cache[6] = ($event: any) => ($setup.setShowSearchbar()))
                              }, {
                                default: _withCtx(() => [
                                  _createVNode(_component_ion_icon, {
                                    slot: "icon-only",
                                    icon: $setup.search
                                  }, null, 8, ["icon"])
                                ]),
                                _: 1
                              }))
                            : _createCommentVNode("", true),
                          _createVNode(_component_cart_button)
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })),
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { size: "6" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, {
                        color: $setup.selectedCategoryId == 'all' ? 'light' : 'primary',
                        class: "ion-no-margin ion-text-center",
                        id: "category-trigger",
                        button: ""
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createVNode(_component_ion_icon, {
                            slot: "start",
                            icon: $setup.filter
                          }, null, 8, ["icon"]), [
                            [_vShow, $setup.selectedCategoryId == 'all']
                          ]),
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createElementVNode("b", null, _toDisplayString($setup.selectedCategoryId == 'all' ? $setup.t('category') :
                  $setup.getLocalizedStr($setup.productCategories.find(c => c.id == $setup.selectedCategoryId), 'title', 'titleEn')), 1)
                            ]),
                            _: 1
                          }),
                          _withDirectives(_createVNode(_component_ion_icon, {
                            slot: "end",
                            icon: $setup.closeCircle,
                            style: {"margin-inline-start":"0"},
                            onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => ($setup.selectedCategoryId = 'all'), ["stop"]))
                          }, null, 8, ["icon"]), [
                            [_vShow, $setup.selectedCategoryId != 'all']
                          ])
                        ]),
                        _: 1
                      }, 8, ["color"]),
                      _createVNode(_component_ion_popover, {
                        trigger: "category-trigger",
                        size: "auto",
                        "dismiss-on-select": true
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_content, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_item, {
                                lines: "full",
                                button: "",
                                onClick: _cache[8] || (_cache[8] = ($event: any) => ($setup.selectedCategoryId = 'all'))
                              }, {
                                default: _withCtx(() => [
                                  ($setup.selectedCategoryId == 'all')
                                    ? (_openBlock(), _createBlock(_component_ion_icon, {
                                        key: 0,
                                        slot: "start",
                                        icon: $setup.checkmark
                                      }, null, 8, ["icon"]))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString($setup.t('all')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.productCategories, (category) => {
                                return (_openBlock(), _createBlock(_component_ion_item, {
                                  lines: "full",
                                  key: category.id,
                                  button: "",
                                  onClick: ($event: any) => ($setup.selectedCategoryId = category.id)
                                }, {
                                  default: _withCtx(() => [
                                    ($setup.selectedCategoryId == category.id)
                                      ? (_openBlock(), _createBlock(_component_ion_icon, {
                                          key: 0,
                                          slot: "start",
                                          icon: $setup.checkmark
                                        }, null, 8, ["icon"]))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_ion_label, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString($setup.getLocalizedStr(category, 'title', 'titleEn')), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, { size: "6" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, {
                        color: $setup.selectedPriceRange == 'all' ? 'light' : 'primary',
                        class: "ion-no-margin ion-text-center",
                        id: "price-trigger",
                        button: ""
                      }, {
                        default: _withCtx(() => [
                          _withDirectives(_createVNode(_component_ion_icon, {
                            slot: "start",
                            icon: $setup.filter
                          }, null, 8, ["icon"]), [
                            [_vShow, $setup.selectedPriceRange == 'all']
                          ]),
                          _createVNode(_component_ion_label, null, {
                            default: _withCtx(() => [
                              _createElementVNode("b", null, _toDisplayString($setup.selectedPriceRange == 'all' ? $setup.t('price') : $setup.selectedPriceRange), 1)
                            ]),
                            _: 1
                          }),
                          _withDirectives(_createVNode(_component_ion_icon, {
                            slot: "end",
                            icon: $setup.closeCircle,
                            style: {"margin-inline-start":"0"},
                            onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => ($setup.selectedPriceRange = 'all'), ["stop"]))
                          }, null, 8, ["icon"]), [
                            [_vShow, $setup.selectedPriceRange != 'all']
                          ])
                        ]),
                        _: 1
                      }, 8, ["color"]),
                      _createVNode(_component_ion_popover, {
                        trigger: "price-trigger",
                        "dismiss-on-select": true
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_content, null, {
                            default: _withCtx(() => [
                              _createVNode(_component_ion_item, {
                                lines: "full",
                                button: "",
                                onClick: _cache[10] || (_cache[10] = ($event: any) => ($setup.selectedPriceRange = 'all'))
                              }, {
                                default: _withCtx(() => [
                                  ($setup.selectedPriceRange == 'all')
                                    ? (_openBlock(), _createBlock(_component_ion_icon, {
                                        key: 0,
                                        slot: "start",
                                        icon: $setup.checkmark
                                      }, null, 8, ["icon"]))
                                    : _createCommentVNode("", true),
                                  _createVNode(_component_ion_label, null, {
                                    default: _withCtx(() => [
                                      _createTextVNode(_toDisplayString($setup.t('all')), 1)
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _: 1
                              }),
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredPriceRange(), (range) => {
                                return (_openBlock(), _createBlock(_component_ion_item, {
                                  lines: "full",
                                  key: range.value,
                                  button: "",
                                  onClick: ($event: any) => ($setup.selectedPriceRange = range.value)
                                }, {
                                  default: _withCtx(() => [
                                    ($setup.selectedPriceRange == range.value)
                                      ? (_openBlock(), _createBlock(_component_ion_icon, {
                                          key: 0,
                                          slot: "start",
                                          icon: $setup.checkmark
                                        }, null, 8, ["icon"]))
                                      : _createCommentVNode("", true),
                                    _createVNode(_component_ion_label, null, {
                                      default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(range.value), 1)
                                      ]),
                                      _: 2
                                    }, 1024)
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              }), 128))
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      _createVNode(_component_ion_content, {
        onIonScroll: $setup.handleScroll,
        scrollEvents: true
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ion_refresher, {
            slot: "fixed",
            onIonRefresh: _cache[11] || (_cache[11] = ($event: any) => ($setup.fetchLatestProducts($event)))
          }, {
            default: _withCtx(() => [
              _createVNode(_component_ion_refresher_content)
            ]),
            _: 1
          }),
          _withDirectives(_createVNode(_component_ion_grid, { fixed: "" }, {
            default: _withCtx(() => [
              ($setup.loading || $setup.delayLoad)
                ? (_openBlock(), _createBlock(_component_loading_skeleton, {
                    key: 0,
                    useGrid: true,
                    numOfItems: 16
                  }))
                : (_openBlock(), _createElementBlock("div", _hoisted_2, [
                    _createVNode(_component_ion_row, null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.giftProducts, (product) => {
                          return (_openBlock(), _createBlock(_component_ion_col, {
                            "size-xs": "6",
                            "size-md": "4",
                            "size-xl": "3",
                            key: product.id
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_product_card, {
                                product: product,
                                userLoggedIn: $setup.userLoggedIn,
                                showActionButtons: false
                              }, null, 8, ["product", "userLoggedIn"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.gameProducts, (product) => {
                          return (_openBlock(), _createBlock(_component_ion_col, {
                            "size-xs": "6",
                            "size-md": "4",
                            "size-xl": "3",
                            key: product.id
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_product_card, {
                                product: product,
                                userLoggedIn: $setup.userLoggedIn,
                                showActionButtons: false
                              }, null, 8, ["product", "userLoggedIn"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.filteredProducts().slice(0, $setup.numOfVisibleItems), (product) => {
                          return (_openBlock(), _createBlock(_component_ion_col, {
                            "size-xs": "6",
                            "size-md": "4",
                            "size-xl": "3",
                            key: product.id
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_product_card, {
                                product: product,
                                userLoggedIn: $setup.userLoggedIn,
                                showActionButtons: false,
                                isScrolling: $setup.isScrolling
                              }, null, 8, ["product", "userLoggedIn", "isScrolling"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_infinite_scroll, {
                      onIonInfinite: _cache[12] || (_cache[12] = ($event: any) => ($setup.loadData($event))),
                      threshold: "100px",
                      id: "infinite-scroll"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_infinite_scroll_content, {
                          "loading-spinner": "bubbles",
                          "loading-text": $setup.t('loadingMore')
                        }, null, 8, ["loading-text"])
                      ]),
                      _: 1
                    })
                  ]))
            ]),
            _: 1
          }, 512), [
            [_vShow, !$setup.isSearching || $setup.searchKeyword]
          ])
        ]),
        _: 1
      }, 8, ["onIonScroll"])
    ]),
    _: 1
  }))
}